import { authApi, authApiTreeviaGateway } from '../clients/AxiosClients'

const loginUser = async (data) => {
	data.clientId = 'smartforest-front'
	return await authApi.post('/api/v1/Auth/login', data)
}

const loginUserTreeviaGateway = async (data) => {
	data.clientId = 'smartforest-front'
	return await authApiTreeviaGateway.post('/api/v1/Auth/login', data)
}

/**
 * Renova a URL (SAS) da imagem de perfil do usuário autenticado.
 * O SAS gerado no login expira em ~30min; este endpoint devolve um novo.
 * Envia o Authorization explicitamente pois o authApi não recebe o header no
 * bootstrap (setAuthorizationAfterLogin só roda no login, não no reload).
 */
const getUserImageUrl = async () => {
	return await authApi.get('/api/v1/Auth/UserImageUrl', {
		headers: { Authorization: localStorage.getItem('jwt') },
	})
}

export { loginUser, loginUserTreeviaGateway, getUserImageUrl }
